<template>
  <div class="index index-ordos">
    <!-- 首屏 Banner -->
    <div class="ordos-hero">
      <video
        ref="heroVideo"
        class="ordos-hero__banner"
        autoplay
        muted
        loop
        playsinline
        preload="auto"
        poster="~@/assets/ly/bannerly-poster.jpg"
        aria-label="陇原工匠人才培育线上学习平台"
        @playing="handleHeroVideoPlaying"
        @waiting="handleHeroVideoWaiting"
        @stalled="handleHeroVideoWaiting"
        @error="handleHeroVideoError"
      >
        <source :src="heroVideoSrc" type="video/mp4" />
      </video>

      <transition name="hero-poster-fade">
        <div v-if="!heroVideoStarted" class="ordos-hero__poster">
          <img src="~@/assets/ly/bannerly-poster.jpg" alt="" />
          <div class="ordos-hero__load-state" aria-live="polite">
            <template v-if="heroVideoError">
              <p>视频加载失败</p>
              <button type="button" @click="retryHeroVideo">重新加载</button>
            </template>
            <template v-else>
              <span class="ordos-hero__spinner"></span>
              <p>{{ heroLoadingText }}</p>
            </template>
          </div>
        </div>
      </transition>

      <div
        v-if="heroVideoStarted && heroVideoBuffering"
        class="ordos-hero__buffering"
        aria-live="polite"
      >
        <span class="ordos-hero__spinner"></span>
        <p>视频缓冲中…</p>
      </div>
    </div>

    <!-- 主体内容区 -->
    <div class="ordos-body">
    <!-- 轮播 + 侧边栏（结构同 index.vue，互不嵌套） -->
    <div class="ordos-content_header">
      <div class="ordos-left_menu" v-if="menuAllList.length > 0">
        <ul>
          <li
            class="menus"
            v-for="item in menuAllList.slice(0, 5)"
            :key="item.id"
            :class="{ active: isOrdosSidebarActive(item.name) }"
            @click="scrollToOrdosModule(item.name)"
          >
            <div class="show_menu">
              <p class="sidebar-title">{{ item.name }}</p>
              <p class="sidebar-sub" v-if="item.son && item.son.length">
                {{ item.son.map(s => s.name).join(' / ') }}
              </p>
            </div>
          </li>
        </ul>
      </div>
      <div class="ordos-content_header__banner">
        <div class="banner-content" v-if="bannerList.length > 0">
          <div class="swiper_banner">
            <swiper
              class="banner ordos-banner"
              ref="ordosBannerSwiper"
              :options="swiperOptionsBanner"
            >
              <swiper-slide
                v-for="(item, index) in bannerList"
                :key="item.image + '_' + index"
              >
                <img
                  v-if="!item.link"
                  class="banner-img"
                  :src="item.image"
                  alt=""
                />
                <a v-else :href="item.link" target="_blank">
                  <img class="banner-img" :src="item.image" alt="" />
                </a>
              </swiper-slide>
              <div class="swiper-pagination" slot="pagination"></div>
            </swiper>
          </div>
        </div>
        <div class="ordos-banner-fallback" v-else></div>
      </div>
    </div>

    <div class="loadState ordos-load" v-if="loadState">
      <ul>
        <li>
          <div class="title"></div>

          <div class="ordos-load-tabs">
            <span></span>
            <span></span>
          </div>

          <div class="list">
            <p></p>
            <p></p>
            <p></p>
            <p></p>
          </div>
        </li>
      </ul>
    </div>

      <div
        v-for="group in ordosModuleGroups"
        :key="group.key"
        :id="'ordos-module-' + group.key"
        class="ordos-module"
      >
        <div class="ordos-module__head">
          <p class="ordos-module__en">{{ group.en }}</p>
          <p class="ordos-module__cn">
            <span class="ordos-module__power">{{ group.powerName }}</span>
            <!-- <span class="ordos-module__colon">：</span> -->
            <span class="ordos-module__sub">{{ group.subTitle }}</span>
          </p>
        </div>
        <div class="ordos-module__toolbar">
          <div class="ordos-module__tabs">
            <span
              v-if="group.basic"
              class="ordos-tab"
              :class="{ 'ordos-tab--active': getOrdosTab(group.key) === 'basic' }"
              @click="setOrdosTab(group.key, 'basic')"
            >基础课程</span>
            <span
              v-if="group.advanced"
              class="ordos-tab"
              :class="{ 'ordos-tab--active': getOrdosTab(group.key) === 'advanced' }"
              @click="setOrdosTab(group.key, 'advanced')"
            >进阶课程</span>
          </div>
          <span
            class="ordos-module__more"
            v-if="getActiveModule(group)"
            @click="goOrdosMore(group)"
          >查看更多 &gt;</span>
        </div>
        <transition name="ordos-course-switch" mode="out-in">
          <ul
            v-if="getActiveModule(group)"
            :key="group.key + '-' + getOrdosTab(group.key)"
            class="ordos-course-list"
            :class="{ 'ordos-course-list--three': (getActiveModule(group).list || []).slice(0, 4).length === 3 }"
          >
            <li
              v-for="subItem in (getActiveModule(group).list || []).slice(0, 4)"
              :key="subItem.id"
              class="ordos-course-item"
            >
              <router-link :to="'/recordedInfo/' + subItem.data_id">
                <div class="ordos-course-item__img">
                  <img v-lazy="subItem.image" :key="subItem.image" alt="" />
                </div>
                <div class="ordos-course-item__title">
                  <p>{{ subItem.name }}</p>
                </div>
              </router-link>
            </li>
          </ul>
        </transition>
      </div>

      <div class="loadState ordos-load" v-if="loadState1">
        <ul><li><div class="title"></div><div class="list"><p></p><p></p><p></p></div></li></ul>
      </div>
    </div>

    <!-- 页脚 -->
    <div class="ordos-footer">
      <p>Copyright◎ 2015-2026 kjcxchina.com All Rights Reserved｜京ICP备16012224号 技术支持：中工科创</p>
    </div>

    <!-- 全国工匠学院作业提示弹框 -->
    <div v-if="taskHintDialog" class="taskHint-dialog">
      <div class="taskHint-content">
        <i class="el-icon-close close" @click="taskHintDialog = false"></i>
        <div class="taskHint-img">
          <img src="@/assets/pc/lmxy_icon.png" alt="">
        </div>
        <div class="taskHint-text">
          <p class="title">作业提示</p>
          <p class="text">完成全部课程学习后，需要点击按钮“填写学习心得”进行填写或上传，截止日期为11月7日24时。</p>
          <a class="but" href="https://qggjxy.org.cn/userCenter" target="_blank">填写学习心得</a>
        </div>
      </div>
    </div>
    <!-- 遮罩层 -->
    <div v-if="taskHintDialog" class="maskSight-box"></div>
  </div>
</template>

<script>
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import { mapMutations } from "vuex";
import { getRequestHost } from "@/utils/axios";
import https from 'https'

export default {
  name: "Index",
  data() {
    const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    const slowTypes = ['slow-2g', '2g', '3g'];
    const useLiteHeroVideo = Boolean(connection && (
      connection.saveData || slowTypes.includes(connection.effectiveType)
    ));

    return {
      bannerList: [], //banner
      liveModule: [], //直播模块
      liveSelect: "", //直播模块选中
      modulelist: [], //模块所有数据
      blogroll: [], //友情链接
      menuAllList: [], //menu
      is_show_sidebar: "0",
      swiperOptionsBanner: {
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        autoplay: {
          delay: 2000,
          stopOnLastSlide: false,
          disableOnInteraction: true,
        },
        loop: true,
        pagination: {
          el: ".swiper-pagination",
          clickable: true, //是否可点击
        },
      },
      websiteData: "",
      textCourseList: [], //文本课程
      openClassList: "", //开放式班级
      loadState:true,
      loadState1:true,

      loading:'',
      advertList:[],//广告位
      commonExamList:[],//公开考试列表
      // 模块
      moduleListHead: [],
      isActive: 0,
      moduleItem: {},
      taskHintDialog: false, // 劳模学院提示
      siteInfo: {},
      ordosModuleMeta: [
        { en: 'LEADERSHIP', power: '引领力' },
        { en: 'ACHIEVEMENT POWER', power: '成就力' },
        { en: 'CREATIVITY', power: '创新力' },
        { en: 'CONCENTRATION', power: '专注力' },
        { en: 'HERITAGE POWER', power: '传承力' },
      ],
      ordosModuleTab: {},
      ordosSidebarActive: '引领力',
      isHeroScrolling: false,
      heroTouchStartY: 0,
      heroVideoSrc: useLiteHeroVideo
        ? require('@/assets/ly/bannerly-lite.mp4')
        : require('@/assets/ly/bannerly.mp4'),
      heroVideoStarted: false,
      heroVideoBuffering: true,
      heroVideoError: false,
      heroUsingLiteVideo: useLiteHeroVideo,
      heroSlowLoading: false,
      heroLoadingTimer: null,
    };
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  directives: {
    swiper: directive,
  },
  computed: {
    heroLoadingText() {
      if (this.heroUsingLiteVideo) {
        return '正在加载流畅版视频…';
      }
      if (this.heroSlowLoading) {
        return '网络较慢，正在优化播放…';
      }
      return '视频加载中…';
    },
    ordosModuleGroups() {
      const map = {};
      const order = ['引领力', '成就力', '创新力', '专注力', '传承力'];

      this.modulelist.forEach((item) => {
        const styleId = Number(item.style_id);
        if (![1, 2, 3].includes(styleId)) return;

        const powerName = order.find((power) => item.name.indexOf(power) > -1);
        if (!powerName) return;

        const isBasic = /（基础）|\(基础\)|-基础课程/.test(item.name);
        const isAdvanced = /（进阶）|\(进阶\)|-进阶课程/.test(item.name);
        const baseName = item.name.replace(/（基础）|（进阶）|\(基础\)|\(进阶\)|-基础课程|-进阶课程/g, '').trim();
        const colonIdx = baseName.indexOf('：');
        const subTitle = colonIdx > -1 ? baseName.slice(colonIdx + 1).trim() : '';
        const meta = this.ordosModuleMeta.find((m) => m.power === powerName) || { en: '' };

        if (!map[powerName]) {
          map[powerName] = {
            key: powerName,
            powerName,
            subTitle,
            en: meta.en,
            basic: null,
            advanced: null,
          };
        }

        if (isBasic) map[powerName].basic = item;
        else if (isAdvanced) map[powerName].advanced = item;
        else if (!map[powerName].basic) map[powerName].basic = item;
        else map[powerName].advanced = item;
      });

      return order
        .filter((key) => map[key] && (map[key].basic || map[key].advanced))
        .map((key) => map[key]);
    },
  },
  created() {
    this.getWebsiteInfo()
  },
  mounted() {
    this.prepareHeroVideo();
    this.getNeedLogin(); // 判断是否需要登录
    this.getBenner(); // 获取banner
    this.getLliveModule(); // 获取直播课堂
    this.getModule(); // 获取首页模块
    this.getTextCourse(); // 获取文本课程
    this.getAdvert(); // 获取广告条
    this.getOpenExam(); // 获取公开考试

    // 首屏视频：滚轮向下时整屏滚到内容区
    window.addEventListener('wheel', this.handleHeroWheel, { passive: false });

    // 移动端触摸向上滑动时，也整屏滚到内容区
    window.addEventListener('touchstart', this.handleHeroTouchStart, { passive: true });
    window.addEventListener('touchmove', this.handleHeroTouchMove, { passive: false });
    // 劳模学院塞上工匠提示框显示隐藏
    // if (this.siteInfo.id == 108) {
    //   console.log(Number(this.$route.query.studyProgress));
    //   console.log(localStorage.getItem('taskHintDialog'));
      
    //   if (Number(this.$route.query.studyProgress) >= 100) {
    //     if (!localStorage.getItem('taskHintDialog')) {
    //       this.taskHintDialog = true
    //       localStorage.setItem("taskHintDialog", "true");
    //     }
    //   }
    // }
    // this.websiteData = JSON.parse(localStorage.getItem('websiteState'))
  },
  beforeDestroy() {
    this.clearHeroLoadingTimer();
    window.removeEventListener('wheel', this.handleHeroWheel);
    window.removeEventListener('touchstart', this.handleHeroTouchStart);
    window.removeEventListener('touchmove', this.handleHeroTouchMove);
  },
  methods: {
    ...mapMutations(["ShowLoginModal", "ShowTipModal", "CloseTipModal"]), //登录弹窗
    prepareHeroVideo() {
      this.heroLoadingTimer = window.setTimeout(() => {
        if (this.heroVideoStarted) return;

        this.heroSlowLoading = true;
        if (!this.heroUsingLiteVideo) {
          this.switchToLiteHeroVideo();
        }
      }, 6000);
    },
    clearHeroLoadingTimer() {
      if (this.heroLoadingTimer) {
        window.clearTimeout(this.heroLoadingTimer);
        this.heroLoadingTimer = null;
      }
    },
    switchToLiteHeroVideo() {
      if (this.heroUsingLiteVideo) return;

      this.heroUsingLiteVideo = true;
      this.heroVideoSrc = require('@/assets/ly/bannerly-lite.mp4');
      this.heroVideoError = false;
      this.heroVideoBuffering = true;

      this.$nextTick(() => {
        const video = this.$refs.heroVideo;
        if (!video) return;
        video.load();
        const playPromise = video.play();
        if (playPromise && playPromise.catch) {
          playPromise.catch(() => {});
        }
      });
    },
    handleHeroVideoPlaying() {
      this.heroVideoStarted = true;
      this.heroVideoBuffering = false;
      this.heroVideoError = false;
      this.clearHeroLoadingTimer();
    },
    handleHeroVideoWaiting() {
      this.heroVideoBuffering = true;
    },
    handleHeroVideoError() {
      if (!this.heroUsingLiteVideo) {
        this.switchToLiteHeroVideo();
        return;
      }

      this.heroVideoError = true;
      this.heroVideoBuffering = false;
      this.clearHeroLoadingTimer();
    },
    retryHeroVideo() {
      const video = this.$refs.heroVideo;
      if (!video) return;

      this.heroVideoError = false;
      this.heroVideoBuffering = true;
      this.heroSlowLoading = false;
      video.load();
      const playPromise = video.play();
      if (playPromise && playPromise.catch) {
        playPromise.catch(() => {
          this.heroVideoError = true;
          this.heroVideoBuffering = false;
        });
      }
    },
    getOrdosTab(groupKey) {
      if (this.ordosModuleTab[groupKey]) {
        return this.ordosModuleTab[groupKey];
      }
      const group = this.ordosModuleGroups.find((g) => g.key === groupKey);
      if (group && group.basic) return 'basic';
      return 'advanced';
    },
    setOrdosTab(groupKey, tab) {
      this.$set(this.ordosModuleTab, groupKey, tab);
    },
    getActiveModule(group) {
      const tab = this.getOrdosTab(group.key);
      if (tab === 'advanced' && group.advanced) return group.advanced;
      if (group.basic) return group.basic;
      return group.advanced;
    },
    goOrdosMore(group) {
      const module = this.getActiveModule(group);
      if (!module) return;
      this.$router.push('/courseList?name=' + module.name + '&id=' + module.id);
    },
    // 五力名称标准化，避免菜单名称带“：课程名”导致锚点找不到
    normalizeOrdosPowerName(name) {
      const text = String(name || '')
        .replace(/（基础）|（进阶）|\(基础\)|\(进阶\)|-基础课程|-进阶课程/g, '')
        .trim();

      const powers = ['引领力', '成就力', '创新力', '专注力', '传承力'];
      const hit = powers.find((item) => text.indexOf(item) > -1);

      if (hit) return hit;

      const colonIdx = text.indexOf('：');
      if (colonIdx > -1) {
        return text.slice(0, colonIdx);
      }

      return text;
    },

    // 左侧五力菜单 active 判断
    isOrdosSidebarActive(name) {
      return this.normalizeOrdosPowerName(name) === this.ordosSidebarActive;
    },

    // 获取 header 高度，锚点滚动时避开固定头部
    getOrdosHeaderHeight() {
      return 72;
    },

    // 获取主体内容开始位置
    getOrdosBodyTop() {
      const bodyEl = this.$el.querySelector('.ordos-body');
      if (bodyEl) {
        return bodyEl.offsetTop;
      }
      return window.innerHeight;
    },

    // 首屏视频向下滚动，直接滑到主体内容
    scrollToOrdosBody() {
      if (this.isHeroScrolling) return;

      this.isHeroScrolling = true;

      const top = this.getOrdosBodyTop();

      window.scrollTo({
        top,
        behavior: 'smooth',
      });

      setTimeout(() => {
        this.isHeroScrolling = false;
      }, 900);
    },

    // 鼠标滚轮：在首屏视频区域向下滚动时，整屏进入内容区
    handleHeroWheel(e) {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      const bodyTop = this.getOrdosBodyTop();

      const isInHero = scrollTop < bodyTop - 10;

      if (isInHero && e.deltaY > 0) {
        e.preventDefault();
        this.scrollToOrdosBody();
      }
    },

    // 移动端触摸开始
    handleHeroTouchStart(e) {
      if (!e.touches || !e.touches.length) return;
      this.heroTouchStartY = e.touches[0].clientY;
    },

    // 移动端向上滑动：首屏视频整屏进入内容区
    handleHeroTouchMove(e) {
      if (!e.touches || !e.touches.length) return;

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
      const bodyTop = this.getOrdosBodyTop();
      const isInHero = scrollTop < bodyTop - 10;

      const currentY = e.touches[0].clientY;
      const diffY = this.heroTouchStartY - currentY;

      if (isInHero && diffY > 30) {
        e.preventDefault();
        this.scrollToOrdosBody();
        this.heroTouchStartY = 0;
      }
    },

    // 点击左侧五力，平滑滚动到对应模块
    scrollToOrdosModule(name) {
      const powerName = this.normalizeOrdosPowerName(name);

      this.ordosSidebarActive = powerName;

      this.$nextTick(() => {
        const el = document.getElementById('ordos-module-' + powerName);
        if (!el) return;

        const headerOffset = this.getOrdosHeaderHeight() + 20;
        const top = el.getBoundingClientRect().top + window.pageYOffset - headerOffset;

        window.scrollTo({
          top,
          behavior: 'smooth',
        });
      });
    },
    //选择直播
    selectLive(data) {
      this.liveSelect = data;
    },
    getChannelNo() {
      // 通过end_time 判断当前直播是否结束 结束提示"当前直播已结束 end_time: 1749713400"
      let nowTime = Date.now() / 1000;
      if(nowTime > this.liveSelect.end_time) {
        this.$message({
          message: '当前直播已结束',
          type: 'warning'
        });
        return;
      }
      this.$router.push("/live/" + this.liveSelect.channel_no+'/'+this.liveSelect.id);
    },
    //获取网站信息
    getWebsiteInfo() {
      this.$axios.post(`/v1/websiteInfo`, { is_pc: 2 }).then((res) => {
        this.siteInfo = res.data.site_info;
        // 劳模学院塞上工匠提示框显示隐藏
        if (res.data.site_info.id == 108) {
          if (Number(this.$route.query.studyProgress) >= 100) {
            if (!localStorage.getItem('taskHintDialog')) {
              this.taskHintDialog = true
              localStorage.setItem("taskHintDialog", "true");
            }
          }
        }
      });
    },
    //判断是否需要登录
    getNeedLogin() {
      if (localStorage.getItem("needLogin")) {
        this.ShowLoginModal();
        localStorage.removeItem("needLogin");
      }
    },
    //获取banner
    getBenner() {
      this.$axios
        .post(`/v1/home/banner`, {
          type: "1",
        })
        .then((res) => {
          if (res.data.length == 1) {
            this.swiperOptionsBanner.loop = false;
          }
          this.bannerList = res.data;
        });
    },
    // 获取广告条
    getAdvert() {
      this.$axios
        .post(`/v1/home/advert`, {
          type: "1",
        })
        .then((res) => {
          if(res.code==0){
            this.advertList = res.data
          }
        });
    },
    // 菜单
    menuClickFirst(item) {
      this.$router.push({
        path: "/courseSelection",
        query: {
          pid: item.id,
        },
      });
    },
    menuClick(id, item) {
      this.$router.push({
        path: "/courseSelection",
        query: {
          pid: id,
          id: item.id,
        },
      });
    },

    //获取直播课堂
    getLliveModule() {
      this.$axios.post(`/v1/home/liveModule`).then((res) => {
        let nowDta = Date.now() / 1000;

        for (let i = 0; i < res.data.length; i++) {
          if (nowDta > res.data[i].live_time && nowDta < res.data[i].end_time) {
            res.data[i].liveNow = true;
          } else {
            res.data[i].liveNow = false;
          }
        }

        this.liveModule = res.data;
        this.liveSelect = res.data[0];
      });
    },
    //获取首页模块
    getModule() {
      // if(this.loadState){
      //  this.loading =  this.$loading({
      //     lock: true,
      //     text: 'Loading',
      //     spinner: 'el-icon-loading',
      //     background: 'rgba(255,255,255,.5)'
      //   });
      // }
      const agent = new https.Agent({  
        rejectUnauthorized: false
      });
      this.$axios.post(`/v1/home/module`).then((res) => {
        if (res.code == 0 && Array.isArray(res.data)) {
          this.getModuleData(res.data);
        } else {
          this.loadState = false;
          this.loadState1 = false;
        }
      });
      this.$axios.post(`/v1/home/category`).then((res) => {
        if (res.code == 0) {
          this.menuAllList = (res.data || []).slice().reverse();
          if (this.menuAllList.length) {
            this.ordosSidebarActive = this.menuAllList[0].name;
          }
        }
      });
      this.$axios.post(`/v1/home/getStatus`, { host: getRequestHost() }).then((res) => {
        if (res.code == 0) {
          this.is_show_sidebar = res.data.is_show_sidebar;
          this.websiteData = res.data;

          // this.menuAllList = res.data;
        }
      });
    },
    //获取各模块数据
    async getModuleData(moduleData) {
      if (!Array.isArray(moduleData) || !moduleData.length) {
        this.modulelist = [];
        this.loadState = false;
        this.loadState1 = false;
        return;
      }

      this.modulelist = moduleData.map((item) => ({ ...item, list: [] }));

      for (let idx = 0; idx < moduleData.length; idx++) {
        const moduleId = moduleData[idx].id;
        const res = await this.$axios.post(`/v1/home/moduleData`, {
          id: moduleId,
        });
        const rawList = res.data && res.data.total ? res.data.data : res.data;
        const list = Array.isArray(rawList)
          ? rawList.filter((item) => item.module_id == moduleId)
          : [];
        const target = this.modulelist.find((item) => item.id == moduleId);

        if (target) {
          this.$set(target, 'list', list);
        }
      }

      this.loadState = false;
      setTimeout(() => {
        this.loadState1 = false;
      }, 1000);
    },
    //跳转活动文章详情
    toActiveInfo(data){
      if(data.type===0){
        this.$router.push('/activeInfo/'+data.data_id);
      }else if(data.type===1){
        window.open(data.pc_link);
      }
    },
    // 文本课程
    getTextCourse() {
      // 文本课程
      this.$axios.post(`/v1/home/textCourse`).then((res) => {
        if (res.code == 0) {
          this.textCourseList = res.data;
        }
      });
      // 开放式班级
      this.$axios
        .post(`/v1/openClass/list`, { page: "1", per_page: "3" })
        .then((res) => {
          if (res.code == 0) {
            this.openClassList = res.data.data;
          }
        });
    },
    // 报名
    sightBtn(id) {
      let _this = this;
      _this.ShowTipModal({
        text: "确定报名该班级？", //提示弹窗内容
        showBtns: true,
        subBtnText: "报名",
        confirmFun: function () {
          _this.CloseTipModal();
          // _this.payNowBtn(_this.courseInfo.detail.id);
          this.$axios
            .post(
              `/v1/openClass/joinOpenClass`,
              { class_id: id },
              { useLog: true }
            )
            .then((res) => {
              _this.ShowTipModal({
                text: res.msg, //提示弹窗内容
              });
            });
        },
      });
    },
    // 获取公开考试
    getOpenExam(){
      this.$axios.post(`/v1/commonExam/list`,{page:1,per_page:4}).then(res=>{
        if(res.code==0){
          this.commonExamList = res.data.data
        }
      })
    }
  },
};
</script>
<style scoped lang="scss">
.index-ordos {
  width: 100%;
  max-width: 100%;
  overflow-x: hidden;
  background: #f5f0ee;

  .content_header {
    display: none;
  }
}

/* ===== 首屏 Banner 1920×1080 ===== */
.ordos-hero {
  position: relative;
  width: 100%;
  height: 100vh;
  max-height: 100vh;
  aspect-ratio: 1920 / 1080;
  overflow: hidden;
  background: #000;

  &__banner {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center center;
    display: block;
  }

  &__poster {
    position: absolute;
    inset: 0;
    z-index: 2;
    overflow: hidden;
    background: #101820;

    > img {
      width: 100%;
      height: 100%;
      display: block;
      object-fit: cover;
      object-position: center center;
    }
  }

  &__load-state,
  &__buffering {
    position: absolute;
    left: 50%;
    z-index: 3;
    display: flex;
    align-items: center;
    gap: 10px;
    max-width: calc(100% - 32px);
    min-height: 42px;
    padding: 0 18px;
    box-sizing: border-box;
    color: #fff;
    font-size: 14px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 22px;
    background: rgba(0, 0, 0, 0.58);
    box-shadow: 0 4px 18px rgba(0, 0, 0, 0.2);
    backdrop-filter: blur(6px);
    transform: translateX(-50%);

    p {
      margin: 0;
      white-space: nowrap;
    }

    button {
      height: 28px;
      margin-left: 4px;
      padding: 0 14px;
      color: #fff;
      cursor: pointer;
      border: 1px solid rgba(255, 255, 255, 0.55);
      border-radius: 14px;
      background: rgba(255, 255, 255, 0.14);
    }
  }

  &__load-state {
    bottom: 48px;
  }

  &__buffering {
    bottom: 32px;
  }

  &__spinner {
    width: 16px;
    height: 16px;
    flex: 0 0 16px;
    box-sizing: border-box;
    border: 2px solid rgba(255, 255, 255, 0.38);
    border-top-color: #fff;
    border-radius: 50%;
    animation: hero-spinner 0.8s linear infinite;
  }
}

.hero-poster-fade-leave-active {
  transition: opacity 0.45s ease;
}

.hero-poster-fade-leave-to {
  opacity: 0;
}

@keyframes hero-spinner {
  to {
    transform: rotate(360deg);
  }
}

.ordos-content_header {
  width: calc(100% - 48px);
  max-width: 1500px;
  height: clamp(520px, 52vw, 793px);
  margin: 0 auto;
  display: flex;
  overflow: hidden;
  background: #8b0018;
  box-shadow: 0 18px 40px rgba(108, 0, 18, 0.12);

  &__banner {
    flex: 1;
    min-width: 0;
    height: 100%;
    position: relative;
    overflow: hidden;
  }

  .banner-content {
    width: 100%;
    height: 100%;
    padding: 0;
    background: transparent;
  }

  .swiper_banner {
    width: 100%;
    height: 100%;
  }

  .ordos-banner {
    width: 100%;
    height: 100%;
    border-radius: 0;
    margin: 0;

    .banner-img {
      width: 100%;
      height: 100%;
      display: block;
      object-fit: cover;
      object-position: center center;
    }
  }

  .ordos-banner-fallback {
    width: 100%;
    height: 100%;
    background:
      radial-gradient(circle at 65% 52%, rgba(255, 205, 92, 0.35) 0%, rgba(255, 205, 92, 0) 28%),
      linear-gradient(135deg, #d71920 0%, #b30014 48%, #8b0018 100%);
  }

  ::v-deep .swiper-pagination {
    display: none;
  }
}

.ordos-left_menu {
  width: clamp(300px, 28.67vw, 430px);
  flex-shrink: 0;
  height: 100%;
  z-index: 2;

  > ul {
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
    list-style: none;
    background: rgba(20, 20, 20, 0.94);
    display: flex;
    flex-direction: column;
  }

  .menus {
    flex: 1;
    min-height: 0;
    position: relative;
    cursor: pointer;
    box-sizing: border-box;
    border-left: none;
    background: transparent;
    transition: background 0.22s ease;

    &:last-child::after {
      display: none;
    }

    /* 左侧橙色竖条 */
    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      width: 4px;
      height: 0;
      background: #ff8f2d;
      transition: height 0.22s ease;
    }

    /* 底部分隔线 */
    &::after {
      content: "";
      position: absolute;
      left: 50%;
      bottom: 0;
      transform: translateX(-50%);
      width: calc(100% - 60px);
      height: 1px;
      border-bottom: 1px solid #5b3d3d;
      background: transparent;
    }

    &:hover,
    &.active {
      background: rgba(255, 255, 255, 0.04);

      &::before {
        height: 61px;
      }

      .sidebar-title {
        font-weight: 600;
        font-size: 18px;
        color: #ff8f2d;
        line-height: 25px;
      }

      .sidebar-sub {
        font-weight: 400;
        font-size: 16px;
        color: #feeaea;
        line-height: 22px;
        -webkit-line-clamp: unset;
      }
    }
  }

  .show_menu {
    height: 100%;
    padding: 0 30px 0 26px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .sidebar-title {
    margin: 0;
    font-size: 16px;
    font-weight: 400;
    color: #ffffff;
    line-height: 22px;
    letter-spacing: 0;
    transition: color 0.22s ease, font-size 0.22s ease, font-weight 0.22s ease;
  }

  .sidebar-sub {
    margin: 8px 0 0;
    font-size: 14px;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.48);
    line-height: 20px;
    word-break: break-all;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    transition: color 0.22s ease, font-size 0.22s ease;
  }
}

/* ===== 鄂尔多斯首页骨架屏，只影响 ordos-load ===== */
.ordos-load {
  width: calc(100% - 48px);
  max-width: 1500px;
  margin: 72px auto 56px;
  padding: 0 20px;
  box-sizing: border-box;

  ul {
    padding: 0;
    margin: 0;
    list-style: none;
  }

  li {
    margin: 0;
  }

  .title {
    width: 260px;
    height: 46px;
    border-radius: 6px;
    background: linear-gradient(
      90deg,
      rgba(0, 0, 0, 0.06),
      rgba(0, 0, 0, 0.035),
      rgba(0, 0, 0, 0.06)
    );
    background-size: 200% 100%;
    animation: ordosSkeleton 1.4s ease-in-out infinite;
  }

  .ordos-load-tabs {
    display: flex;
    gap: 16px;
    margin: 28px 0 24px;

    span {
      display: block;
      width: 120px;
      height: 42px;
      border-radius: 24px;
      background: linear-gradient(
        90deg,
        rgba(0, 0, 0, 0.055),
        rgba(0, 0, 0, 0.03),
        rgba(0, 0, 0, 0.055)
      );
      background-size: 200% 100%;
      animation: ordosSkeleton 1.4s ease-in-out infinite;
    }
  }

  div.list {
    margin-top: 0;
    display: flex;
    justify-content: space-between;
    gap: 20px;

    p {
      flex: 1;
      height: 238px;
      margin: 0;
      border-radius: 8px;
      background: linear-gradient(
        90deg,
        rgba(0, 0, 0, 0.055),
        rgba(0, 0, 0, 0.03),
        rgba(0, 0, 0, 0.055)
      );
      background-size: 200% 100%;
      animation: ordosSkeleton 1.4s ease-in-out infinite;
    }
  }
}

@keyframes ordosSkeleton {
  0% {
    background-position: 100% 0;
  }

  100% {
    background-position: -100% 0;
  }
}
/* ===== 主体内容 ===== */
.ordos-body {
  background-image: url('~@/assets/ly/bg.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: 100% 100%;
  padding: 165px 0 120px;
}

.ordos-module {
  max-width: 1400px;
  margin: 0 auto 56px;
  padding: 0 20px;
  box-sizing: border-box;
  margin-bottom: 30px;

  &__head {
    margin-bottom: 60px;
    margin-top: 113px;
  }

  &__en {
    font-family: PingFang-SC, PingFang-SC;
    font-weight: 800;
    font-size: 40px;
    color: #DAB46F;
    line-height: 56px;
    margin-bottom: 13px;
    // font-family: Georgia, 'Times New Roman', serif;
  }

  &__cn {
    font-size: 0;
    line-height: 1.3;
  }

  &__power {
    font-weight: 800;
    font-size: 44px;
    color: #9E0506;
    line-height: 62px;
    margin-right: 20px;
  }

  &__colon {
    font-size: 28px;
    font-weight: bold;
    color: #8b0018;
  }

  &__sub {
    font-size: 28px;
    font-weight: normal;
    color: #8b0018;
  }

  &__toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 40px;
  }

  &__tabs {
    display: flex;
    gap: 16px;
  }

  &__more {
    font-size: 14px;
    color: #666;
    cursor: pointer;
    white-space: nowrap;
    transition: color 0.3s ease, transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);

    &:hover {
      color: #8b0018;
      transform: translateX(4px);
    }
  }
}

.ordos-tab {
  display: inline-block;
  font-size: 16px;
  cursor: pointer;
  width: 206px;
  height: 66px;
  text-align: center;
  line-height: 66px;
  background: #FFFFFF;
  color: #333;
  box-shadow: 0px 2px 4px 0px rgba(225, 222, 222, 0.5);
  border-radius: 33px;
  box-sizing: border-box;
  user-select: none;
  transition:
    background 0.4s cubic-bezier(0.4, 0, 0.2, 1),
    color 0.35s cubic-bezier(0.4, 0, 0.2, 1),
    box-shadow 0.35s cubic-bezier(0.4, 0, 0.2, 1),
    transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);

  &--active {
    background: linear-gradient(180deg, #CD0C0E 0%, #9E0506 100%);
    color: #fff;
    box-shadow: 0px 6px 16px 0px rgba(158, 5, 6, 0.35);
    transform: translateY(-1px);
  }

  &:hover:not(.ordos-tab--active) {
    color: #9E0506;
    box-shadow: 0px 4px 10px 0px rgba(225, 222, 222, 0.8);
    transform: translateY(-2px);
  }

  &:active {
    transform: scale(0.97);
  }

  &--active:active {
    transform: scale(0.97) translateY(-1px);
  }
}

.ordos-course-switch-enter-active,
.ordos-course-switch-leave-active {
  transition: opacity 0.35s cubic-bezier(0.4, 0, 0.2, 1),
    transform 0.35s cubic-bezier(0.4, 0, 0.2, 1);
}

.ordos-course-switch-enter,
.ordos-course-switch-leave-to {
  opacity: 0;
  transform: translateY(16px);
}

.ordos-course-switch-enter-active .ordos-course-item {
  animation: ordosCourseIn 0.45s cubic-bezier(0.4, 0, 0.2, 1) both;
}

.ordos-course-switch-enter-active .ordos-course-item:nth-child(1) { animation-delay: 0.04s; }
.ordos-course-switch-enter-active .ordos-course-item:nth-child(2) { animation-delay: 0.1s; }
.ordos-course-switch-enter-active .ordos-course-item:nth-child(3) { animation-delay: 0.16s; }
.ordos-course-switch-enter-active .ordos-course-item:nth-child(4) { animation-delay: 0.22s; }

@keyframes ordosCourseIn {
  from {
    opacity: 0;
    transform: translateY(24px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.ordos-course-list {
  display: flex;
  gap: 20px;
  list-style: none;
  padding: 0;
  margin: 0;

  &--three {
    .ordos-course-item__img {
      height: 230px;
    }
  }
}

.ordos-course-item {
  flex: 1;
  min-width: 0;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
  border-bottom: 3px solid transparent;
  transition:
    transform 0.4s cubic-bezier(0.4, 0, 0.2, 1),
    box-shadow 0.4s cubic-bezier(0.4, 0, 0.2, 1),
    border-bottom-color 0.35s ease,
    opacity 0.35s ease;

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 12px 28px rgba(158, 5, 6, 0.12);
    border-bottom-color: #9E0506;
  }

  a {
    text-decoration: none;
    display: block;
  }

  &__img {
    width: 100%;
    height: 202px;
    overflow: hidden;
    background: #f0f0f0;

    img {
      width: 100%;
      height: 100%;
      display: block;
      transition: transform 0.55s cubic-bezier(0.4, 0, 0.2, 1);
    }
  }

  &:hover &__img img {
    transform: scale(1.08);
  }

  &__title {
    padding: 18px 20px;
    font-weight: 500;
    box-sizing: border-box;
    p {
      font-size: 20px;
      color: #333333;
      line-height: 28px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      min-height: 58px;
      transition: color 0.35s ease;
    }
  }

  &:hover &__title p {
    color: #9E0506;
  }
}

.ordos-load {
  max-width: 1500px;
  margin: 0 auto 40px;
}

/* ===== 页脚 ===== */
.ordos-footer {
  background: #8b0018;
  text-align: center;
  padding: 16px 20px;
  height: 80px;
  p {
    font-weight: 400;
    font-size: 15px;
    color: #EAF4FE;
    line-height: 80px;
    margin: 0;
  }
}


.banner-content {
  width: 100%;
  padding: 44px 0;
  background-color: #f7f7f7;
}
.banner_box_bgm{
  width: 100%;
  height: 400px;
  background: rgba(0, 0, 0, 0.06);
  border-radius: 6px;
}
.banner {
  height: 400px;
  border-radius: 8px;
  .banner-img {
    display: block;
    width: 100%;
    height: 100%;
  }
}
.content_header {
  width: 1500px;
  height: 400px;
  margin: 50px auto 0;
  position: relative;
  .swiper_banner {
    position: absolute;
    left: 0;
    top: 0;
  }
}
.flex {
  display: flex;
  align-items: center;
}
.left_menu::-webkit-scrollbar {
  display: none;
}
.left_menu {
  width: 430px;
  height: 400px;

  border-radius: 5px 0px 0px 5px;
  z-index: 9;
  opacity: 1;

  > ul {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 99;
    height: 400px;
    border-radius: 5px 0px 0px 5px;
    display: flex;
    flex-direction: column;
    background: rgba(0, 0, 0, 0.5);
    // overflow-y: auto;
    // overflow-x: hidden;
    .menus {
      flex: 1;
      min-height: 58px;
      color: #fff;
      display: flex;
      align-items: center;
    }
    > li.menus:hover {
      background: rgba(63, 63, 63, 0.5);
      .hide_menu {
        display: block;
      }
    }
    > li.menus {
      overflow: hidden;
      color: #333;
      cursor: pointer;
      width: 430px;

      div.show_menu {
        width: 430px;
        padding: 0 20px;
        display: flex;
        align-items: center;
        // position: relative;
        // z-index: 9;
        // width: 430px;
        // height: 50px;
        // background: ;
        p.title {
          justify-content: space-between;
          span {
            font-size: 16px;
            font-weight: bold;
            color: #fff;
            display: inline-block;
            width: 110px;
          }
          i {
            font-size: 15px;
            color: #fff;
          }
        }
        p.list_title {
          font-size: 12px;
          color: #fff;
          margin-left: 16px;
        }
      }

      // 隐藏起来的菜单
      .hide_menu {
        display: none;
        position: absolute;
        left: 430px;
        top: 0;
        z-index: 9999;
        box-shadow: 2px 2px 20px 1px rgba(0, 0, 0, 0.2);
        background: rgba(255, 255, 255, 0.9);
        width: 741px;
        height: 400px;
        z-index: 99;
        .menu_cont {
          padding: 24px 25px 0 22px;
          overflow-y: auto;
          div.top_title {
            font-size: 16px;
            font-family: Source Han Sans CN-Bold, Source Han Sans CN;
            font-weight: bold;
            color: #000;
            margin-bottom: 14px;
          }
          .menuList {
            flex-wrap: wrap;
            width: 100%;
            margin-bottom: 30px;
            li {
              margin-right: 29px;
              height: 30px;
              font-size: 14px;
              color: #333333;
            }
            li:hover {
              color: #ff6711;
            }
          }
          .img_tex {
            flex-wrap: wrap;
            width: 100%;
            margin-bottom: 5px;
            align-items: flex-start;
            li {
              width: 155px;
              margin-right: 22px;
              margin-bottom: 15px;
              p.img {
                width: 155px;
                height: 84px;
                margin: 0 auto;

                img {
                  width: 100%;
                  height: 100%;
                  border-radius: 5px;
                }
              }
              p.text {
                font-size: 14px;
                color: #666666;
                margin-top: 10px;
                overflow: hidden !important;
                text-overflow: ellipsis !important;
                -webkit-line-clamp: 1;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                white-space: normal;
                word-wrap: break-word;
              }
            }
            li:nth-child(4n) {
              margin-right: 0;
            }
          }
          .text_info {
            width: 100%;
            padding-bottom: 30px;
            li {
              flex-wrap: wrap;
              margin-right: 24px;
              width: 155px;
              height: 100px;
              position: relative;

              p.img {
                width: 155px;
                height: 100px;
                position: absolute;
                left: 0;
                top: 0;
                z-index: 1;
                img {
                  width: 100%;
                  height: 100%;
                  border-radius: 5px;
                }
              }
              p.text {
                position: absolute;
                left: 0;
                bottom: 0;
                width: 155px;
                height: 23px;
                background: rgba(0, 0, 0, 0.5);
                border-bottom-right-radius: 5px;
                border-bottom-left-radius: 5px;
                padding-left: 8px;
                color: #fff;
                line-height: 23px;
                z-index: 2;
              }
              span {
                display: block;
                position: absolute;
                left: 50%;
                transform: translateX(-50%);
                border-radius: 0 0 5px 5px;
              }
              span.box_shadow1 {
                width: 135px;
                height: 23px;
                background: rgba(0, 0, 0, 0.6);
                bottom: -6px;
                opacity: 0.6;
                // z-index: 0;
              }
              span.box_shadow2 {
                width: 125px;
                height: 23px;
                background: rgba(0, 0, 0, 0.4);
                opacity: 0.4;
                bottom: -12px;
                // z-index: 0;
              }
            }
            li:nth-child(4n) {
              margin-right: 0;
            }
          }
        }
      }
    }
  }
}
.banner,
.content {
  width: 1500px;
  margin: 0 auto;
  .title-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 34px;
    .title {
      min-width: 140px;
      font-size: 30px;
      color: #333;
      display: flex;
      align-items: flex-end;
      .title-text {
        position: relative;
        .text {
          position: relative;
          z-index: 1;
        }
        &::after {
          content: "";
          display: block;
          width: 100%;
          height: 14px;
          border-radius: 7px;
          background-image: linear-gradient(90deg, #ffc30b, #fff7b9);
          position: absolute;
          bottom: 0;
          z-index: 0;
        }
      }
    }
    .sub-title {
      font-size: 16px;
      margin-left: 18px;
    }
    .more {
      height: 19.88px;
      padding-right: 22px;
      font-size: 14px;
      color: #999;
      background: url(~@/assets/arrows-right.png) no-repeat;
      background-size: 19.88px;
      background-position: right;
      cursor: pointer;
    }
  }
}
.banner-content ::v-deep .swiper-pagination-bullet {
  display: inline-block;
  width: 48px;
  height: 6px;
  background: #ccc;
  border-radius: 6px;
  margin: 0 10px;
}

.banner-content ::v-deep .swiper-pagination-bullet-active {
  background: #fff;
}
.live-content {
  width: 100%;
  padding: 68px 0;
}
.content-box-list .content-box:nth-child(odd) {
  background-color: #fff;
}
.content-box-list .content-box:nth-child(even) {
  background-color: #f7f7f7;
}
.live-list-content {
  .live-list {
    box-shadow: 0px 0px 14px 0px rgba(0, 0, 0, 0.14);
    border-radius: 0px 6px 6px 0px;
    float: left;
    overflow-y: auto;
  }
  .live-info {
    padding: 19px 20px 24px 15px;
    position: relative;
    cursor: pointer;
    &::after {
      content: "";
      display: block;
      width: 2px;
      height: 50px;
      background-color: rgba(0, 0, 0, 0.06);
      position: absolute;
      bottom: 0;
      left: 29px;
    }
    &.active {
      background: #f5f5f5;
    }
  }
  .live-now {
    height: 30px;
    line-height: 30px;
    padding-left: 40px;
    font-size: 16px;
    font-weight: 800;
    color: #f5a623;
    background: url(~@/assets/live-now-ico.png) no-repeat;
    background-size: 30px;
    background-position: left;
    margin-bottom: 7px;
  }
  .live-date {
    height: 20px;
    line-height: 20px;
    padding-left: 34px;
    background: url(~@/assets/clock-ico.png) no-repeat;
    background-size: 20px;
    background-position: 6px center;
    font-size: 12px;
    font-weight: 500;
    color: #999999;
    margin-bottom: 12px;
  }
  .live-title {
    padding-left: 40px;
    font-size: 16px;
    color: #333;
    margin-bottom: 25px;
    a {
      color: #333;
    }
  }
  .live-lecturer {
    padding-left: 40px;
    font-size: 12px;
    color: #666;
  }
  .live-btn {
    width: 94px;
    height: 34px;
    line-height: 34px;
    text-align: center;
    box-shadow: 0px 2px 4px 0px rgba(101, 67, 11, 0.2);
    border-radius: 6px;
    position: absolute;
    right: 20px;
    cursor: pointer;
    &.into {
      background: #ffc30b;
      color: #333;
    }
    &.subscribe {
      background: #254ed4;
      color: #fff;
    }
  }
}
.content-box {
  width: 100%;
  padding: 58px 0 44px;
  .data-list {
    width: 1224px;
    margin-left: -12px;
    display: flex;
    flex-wrap: wrap;
  }
  .data-info {
    width: 282px;
    background: #ffffff;
    box-shadow: 0px 0px 14px 0px rgba(0, 12, 40, 0.14);
    border-radius: 6px;
    margin: 0 12px 24px 12px;
    transition: all 0.2s ease-out;
    &:hover {
      position: relative;
      transform: translateY(-6px);
    }
  }
  .data-img {
    width: 100%;
    height: 156px;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    margin-bottom: 15px;
  }
  .data-box {
    padding: 0 20px;
  }
  .data-title {
    display: block;
    font-size: 16px;
    color: #333;
    margin-bottom: 8px;
  }
  .data-tip {
    font-size: 12px;
    color: #999;
    margin-bottom: 20px;
  }
  .data-price {
    width: 100%;
    height: 54px;
    border-top: 1px solid #e5e5e5;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .price {
      font-size: 18px;
      font-weight: 800;
      color: #cd1b14;
    }
    .num {
      font-size: 12px;
      color: #999999;
    }
  }
  &.style_2 {
    .data-info:first-child {
      width: 588px;
      position: relative;
      .data-img {
        width: 100%;
        height: 100%;
        border-radius: 6px;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
      }
      .data-box {
        box-sizing: border-box;
        width: 100%;
        height: 88px;
        background-color: rgba(0, 12, 40, 0.4);
        border-radius: 0px 0px 6px 6px;
        position: absolute;
        bottom: 0;
        z-index: 2;
      }
      .data-title {
        padding: 18px 0 10px;
        color: #fff;
        margin: 0;
      }
      .data-tip {
        display: none;
      }
      .data-price {
        height: auto;
        border: none;
        .price {
          color: #fff;
        }
      }
    }
  }
  .active-list{
    display: flex;
    // justify-content: space-between;
    .active-sub-title{
      height: 20px;
      font-size: 14px;
      color: #999;
      line-height: 20px;
      -webkit-line-clamp: 1;
    }
    .active-name{
      height: 44px;
      font-size: 16px;
      color: #333;
    }
    &.style_7{
      .active-info{
        width: 385px;
        height: 306px;
        background-color: #FFF;
        box-shadow: 0px 0px 14px 1px rgba(0,12,40,0.14);
        border-radius: 6px;
        overflow: hidden;
        cursor: pointer;
        transition: all 0.2s ease-out;
        margin-right: 24px;
        &:hover {
          position: relative;
          transform: translateY(-6px);
        }
      }
      .active-info:nth-child(3n){
        margin-right: 0;
      }
      .active-img{
        width: 100%;
        height: 217px;
        margin-bottom: 10px;
      }
      .active-cent{
        padding: 0 22px;
      }
    }

    &.style_8{
      .active-info{
        box-sizing: border-box;
        width: 385px;
        height: 123px;
        padding: 0 18px;
        background-color: #FFF;
        box-shadow: 0px 0px 14px 1px rgba(0,12,40,0.14);
        border-radius: 6px;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        transition: all 0.2s ease-out;
        &:hover {
          position: relative;
          transform: translateY(-6px);
        }
      }
      .active-img{
        width: 160px;
        height: 90px;
        border-radius: 6px;
      }
      .active-cent{
        width: 180px;
      }
    }
  }
  
  &.content2 {
    background-color: #fff;
    .boutique-info.big {
      width: 576px;
      position: relative;
      .boutique-img {
        position: absolute;
        width: 100%;
        height: 100%;
        margin-bottom: 0;
        z-index: 0;
      }
      .boutique-box {
        box-sizing: border-box;
        width: 100%;
        padding-top: 18px;
        background-color: rgba(0, 12, 40, 0.29);
        position: absolute;
        bottom: 0;
        left: 0;
        .boutique-title,
        .price,
        .num {
          color: #fff;
        }
      }
      .boutique-price {
        border: none;
      }
    }
  }
}
.recommended-content {
  background-color: #fff;
  padding: 58px 0 46px;
}
.recommended-big-show {
  width: 588px;
  height: 432px;
  background: #ffffff;
  box-shadow: 0px 0px 14px 0px rgba(0, 12, 40, 0.14);
  border-radius: 6px;
  float: left;
  .recommended-box {
    padding: 0 20px;
  }
  .recommended-img {
    width: 100%;
    height: 318px;
    margin-bottom: 20px;
  }
  .recommended-title {
    font-size: 16px;
    color: #333;
    margin-bottom: 24px;
  }
  .recommended-price {
    display: flex;
    justify-content: space-between;
    .price {
      font-size: 18px;
      font-weight: 800;
      color: #cd1b14;
    }
    .num {
      font-size: 12px;
      color: #999;
    }
  }
}
.recommended-list {
  width: 588px;
  overflow: hidden;
  float: right;
  .recommended-info {
    width: 282px;
    height: 204px;
    background: #ffffff;
    box-shadow: 0px 0px 14px 0px rgba(0, 12, 40, 0.14);
    border-radius: 6px;
    float: left;
    margin-bottom: 22px;
    &:nth-child(2n-1) {
      margin-right: 24px;
    }
  }
  .recommended-img {
    width: 100%;
    height: 156px;
    margin-bottom: 14px;
  }
  .recommended-box {
    padding: 0 15px;
    display: flex;
    justify-content: space-between;
  }
  .recommended-title {
    width: 156px;
    font-size: 14px;
    color: #333;
    overflow: hidden;
    white-space: nowrap;
    -o-text-overflow: ellipsis;
    text-overflow: ellipsis;
  }
  .recommended-price {
    font-size: 18px;
    font-weight: 800;
    color: #cd1b14;
  }
}

.series-list {
  display: flex;
  justify-content: space-between;
  .series-info {
    width: 384px;
     height: 250px;
    border-radius: 6px;
    overflow: hidden;
    position: relative;
    cursor: pointer;
  }
  .series-img {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 0;
  }
  .series-text {
    box-sizing: border-box;
    position: absolute;
    width: 100%;
    height: 100%;
    padding: 26px 20px 20px;
    background-color: rgba(0, 0, 0, 0.14);
    position: relative;
  }
  .series-title {
    font-size: 16px;
    font-weight: 900;
    color: #fff;
    margin-bottom: 14px;
  }
  .marks {
    overflow: hidden;
    margin-bottom: 34px;
    .mark {
      padding: 0 8px;
      height: 18px;
      line-height: 18px;
      background: rgba(255, 255, 255, 0.3);
      border-radius: 10px 2px 10px 2px;
      font-size: 12px;
      color: #ffffff;
      text-align: center;
      float: left;
      margin-right: 12px;
    }
  }
  .series-user-list {
    overflow: hidden;
  }
  .series-bottom {
    box-sizing: border-box;
    width: 100%;
    padding: 0 20px;
    position: absolute;
    left: 0;
    bottom: 0;
  }
  .series-bottom-top {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    padding-bottom: 20px;
  }
  .series-price {
    font-size: 18px;
    color: #fff;
  }
  .series-user {
    float: left;
    margin-right: 10px;
    .series-user-img {
      width: 34px;
      height: 34px;
      border: 2px solid #fff;
      border-radius: 50%;
    }
  }
}
.series-content6{
  .series-list{
     justify-content: flex-start;
     flex-wrap: wrap;
     li{
      margin-right: 24px;
      margin-bottom: 24px;
      &:nth-child(4n){
        margin-right: 0;
      }
    }
    .series-info{
      width: 282px;
      height: 240px;
    }
  }
}
.lecturer-content {
  .lecturer-list {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    &.lecturer{
      justify-content: space-between;
      .lecturer-info{
        padding-bottom: 20px;
      }
      .lecturer-course{
        // height: 85px;
        -webkit-line-clamp: 6;
      }
      .lecturer-img {
        height: 282px;
      }
    }
  }
  .lecturer-info {
    width: 282px;
    background: #ffffff;
    box-shadow: 0px 0px 14px 0px rgba(0, 12, 40, 0.14);
    border-radius: 6px;
    margin-bottom: 10px;
    overflow: hidden;
    cursor: pointer;
  }
  .openBox {
    width: 282px;
    height: 120px !important;
    .btn {
      display: flex;
      justify-content: flex-end;
      margin-right: 20px;
      p {
        width: 70px;
        height: 26px;
        background: #9f1106;
        color: #fff;
        font-size: 12px;
        line-height: 26px;
        border-radius: 4px;
        cursor: pointer;
        text-align: center;
      }
    }
  }
  .lecturer-img {
    width: 100%;
    height: auto;
  }
  .lecturer-name {
    display: flex;
    align-items: center;
    padding: 14px 20px 8px;
    font-size: 16px;
    font-weight: 900;
    color: #333;
  }
  .lecturer-leve {
    padding: 2px 4px;
    background-color: rgba(255, 195, 11, 0.14);
    font-size: 12px;
    color: #f5a623;
    margin-left: 8px;
  }
  .lecturer-course {
    padding: 0 20px 0px;
    font-size: 14px;
    color: #666;
  }
}
.blogroll {
  .content {
    padding: 59px 0 89px;
    font-size: 14px;
    color: #333;
  }
  .blogroll-link {
    font-size: 14px;
    color: #1d1a32;
    margin-left: 10px;
    margin-right: 52px;
  }
}
.service {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translateY(-50%);
  margin-left: 625px;
  z-index: 10;
  cursor: pointer;
  .text-box {
    padding: 10px;
    padding-left: 0;
    position: relative;
    z-index: 1;
  }
  .text {
    width: 24px;
    padding: 40px 13px 10px;
    box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.2);
    background: url(~@/assets/headset.png) no-repeat center 11px #fff;
    background-size: 22px;
    border-radius: 5px;
    font-size: 12px;
  }
  .code {
    width: 110px;
    padding: 8px 0 91px;
    background: url(~@/assets/code.jpg) no-repeat center 44px #fff;
    background-size: 75px 75px;
    box-shadow: 0px 1px 10px 1px rgba(0, 0, 0, 0.2);
    border-radius: 5px;
    font-size: 12px;
    line-height: 16px;
    text-align: center;
    position: absolute;
    left: -110px;
    bottom: 10px;
    z-index: 0;
    display: none;
  }
  &:hover {
    .text-box {
      overflow: hidden;
    }
    .text {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
    .code {
      display: block;
      border-bottom-right-radius: 0;
    }
  }
}
// 文本课程
.textCourse {
  ul {
    justify-content: flex-start;
    li.lecturer-info {
      width: 384px;
      height: 330px;
      margin-right: 20px;
      img {
        height: 250px;
      }
      .lecturer-course span {
        color: #999;
      }
    }
    li:nth-child(3n){
      margin-right: 0;
    }
  }
}
.loadState{
  width: 1500px;
  margin: 0 auto;
  // height: 400px;
  // display: none;
  li{
    margin-top: 40px;
  }
  .title{
    width: 300px;
    height: 40px;
     background: rgba(0, 0, 0, 0.06);
    
  }
  div.list{
    margin-top: 34px;
      display: flex;
      justify-content: space-between;
      p{
        border-radius: 6px;
         width: 384px;
         height: 250px;
         background: rgba(0, 0, 0, 0.06);
        // background: linear-gradient(-45deg, rgba(0,0,0,.1),rgba(0,0,0,.05));
        // background-size: 400% 400%;
        // -webkit-animation: Gradient 15s ease infinite;
        // -moz-animation: Gradient 15s ease infinite;
        // animation: Gradient 15s ease infinite;

      }
    }
}
// 广告条
.vert_box{
  width: 1500px;
  margin: 20px auto;
  img{
    width: 1500px;
    max-height: 120px;
  }
}
// 公开考试样式
.examCont{
  ul{
    display: flex;
    li{
      width: 23%;
      background: #fff;
      box-shadow: 0px 0px 14px 1px rgba(0, 12, 40, 0.14);
      border-radius: 6px;
      box-sizing: border-box;
      padding:15px;
      margin-right: 2%;
      p.exam_name{
        font-size: 16px;
        margin-bottom: 10px;
      }
      div.time_{
        p{
          font-size: 14px;
          color: #666;
          margin-bottom: 5px;
        }
      }
      .down_num{
        font-size: 14px;
        color: #666;
      }
      div.btn{
        display: inline-block;
        background: #254ed4;
        padding: 5px 10px;
        margin-top: 10px;
        cursor: pointer;
        border-radius: 5px;
        color: #fff;
        font-size: 14px;
      }
    }
  }
}
// @-webkit-keyframes Gradient {
//     0% {
//         background-position: 0% 50%
//     }
//     50% {
//         background-position: 100% 50%
//     }
//     100% {
//         background-position: 0% 50%
//     }
// }

// @-moz-keyframes Gradient {
//     0% {
//         background-position: 0% 50%
//     }
//     50% {
//         background-position: 100% 50%
//     }
//     100% {
//         background-position: 0% 50%
//     }
// }

// @keyframes Gradient {
//     0% {
//         background-position: 0% 50%
//     }
//     50% {
//         background-position: 100% 50%
//     }
//     100% {
//         background-position: 0% 50%
//     }
// }
.content_cont_box {
  margin-top: 50px;
  .cont_box1 {
    width: 1500px;
    margin: 0 auto;
    position: relative;
  .more {
    text-align: right;
    position: absolute;
    right: 0;
    }
    .title_cont {
      width: 1500px;
      margin: 0 auto 30px;
      justify-content: space-between;
      .left_cont {
        align-items: flex-end;
        flex: 1;
        ul {
          flex: 1;
          margin-left: 44px;
          display: flex;
          align-items: center;
          li.active {
            color: #0065df;
            :after {
              content: "";
              position: absolute;
              left: 50%;
              bottom: -10px;
              transform: translateX(-50%);
              width: 20px;
              height: 2px;
              border-radius: 2px;
              background: #0065df;
            }
          }
          li {
            margin-right: 40px;
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 400;
            color: #666;
            position: relative;
            line-height: 32px;
          }
        }
        .cursor {
          cursor: pointer;
        }
      }
      .title {
        font-size: 28px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #333;
      }
    }
    .course_list {
      width: 100%;
      padding: 0px 0 44px;
      .data-list {
        width: 1224px;
        margin-left: -12px;
        display: flex;
        flex-wrap: wrap;
      }
      .data-info {
        width: 282px;
        background: #ffffff;
        box-shadow: 0px 0px 14px 0px rgba(0, 12, 40, 0.14);
        border-radius: 6px;
        margin: 0 12px 24px 12px;
        transition: all 0.2s ease-out;
        &:hover {
          position: relative;
          transform: translateY(-6px);
        }
      }
      .data-img {
        width: 100%;
        height: 156px;
        border-top-left-radius: 6px;
        border-top-right-radius: 6px;
        margin-bottom: 15px;
      }
      .data-box {
        padding: 0 20px;
      }
      .data-title {
        display: block;
        font-size: 16px;
        color: #333;
        margin-bottom: 8px;
      }
      .data-tip {
        font-size: 12px;
        color: #999;
        margin-bottom: 20px;
      }
      .data-price {
        width: 100%;
        height: 54px;
        border-top: 1px solid #e5e5e5;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .price {
          font-size: 18px;
          font-weight: 800;
          color: #cd1b14;
        }
        .num {
          font-size: 12px;
          color: #999999;
        }
      }
      &.style_2 {
        .data-info:first-child {
          width: 588px;
          position: relative;
          .data-img {
            width: 100%;
            height: 100%;
            border-radius: 6px;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;
          }
          .data-box {
            box-sizing: border-box;
            width: 100%;
            height: 88px;
            background-color: rgba(0, 12, 40, 0.4);
            border-radius: 0px 0px 6px 6px;
            position: absolute;
            bottom: 0;
            z-index: 2;
          }
          .data-title {
            padding: 18px 0 10px;
            color: #fff;
            margin: 0;
          }
          .data-tip {
            display: none;
          }
          .data-price {
            height: auto;
            border: none;
            .price {
              color: #fff;
            }
          }
        }
      }
      .active-list{
        display: flex;
        // justify-content: space-between;
        .active-sub-title{
          height: 20px;
          font-size: 14px;
          color: #999;
          line-height: 20px;
          -webkit-line-clamp: 1;
        }
        .active-name{
          height: 44px;
          font-size: 16px;
          color: #333;
        }
        &.style_7{
          .active-info{
            width: 385px;
            height: 306px;
            background-color: #FFF;
            box-shadow: 0px 0px 14px 1px rgba(0,12,40,0.14);
            border-radius: 6px;
            overflow: hidden;
            cursor: pointer;
            transition: all 0.2s ease-out;
            margin-right: 24px;
            &:hover {
              position: relative;
              transform: translateY(-6px);
            }
          }
          .active-info:nth-child(3n){
            margin-right: 0;
          }
          .active-img{
            width: 100%;
            height: 217px;
            margin-bottom: 10px;
          }
          .active-cent{
            padding: 0 22px;
          }
        }

        &.style_8{
          .active-info{
            box-sizing: border-box;
            width: 385px;
            height: 123px;
            padding: 0 18px;
            background-color: #FFF;
            box-shadow: 0px 0px 14px 1px rgba(0,12,40,0.14);
            border-radius: 6px;
            overflow: hidden;
            display: flex;
            align-items: center;
            justify-content: space-between;
            cursor: pointer;
            transition: all 0.2s ease-out;
            &:hover {
              position: relative;
              transform: translateY(-6px);
            }
          }
          .active-img{
            width: 160px;
            height: 90px;
            border-radius: 6px;
          }
          .active-cent{
            width: 180px;
          }
        }
      }
      
      &.content2 {
        background-color: #fff;
        .boutique-info.big {
          width: 576px;
          position: relative;
          .boutique-img {
            position: absolute;
            width: 100%;
            height: 100%;
            margin-bottom: 0;
            z-index: 0;
          }
          .boutique-box {
            box-sizing: border-box;
            width: 100%;
            padding-top: 18px;
            background-color: rgba(0, 12, 40, 0.29);
            position: absolute;
            bottom: 0;
            left: 0;
            .boutique-title,
            .price,
            .num {
              color: #fff;
            }
          }
          .boutique-price {
            border: none;
          }
        }
      }
    }
  }
  .flex {
    display: flex;
  }
  padding: 58px 0 44px;
  .data-list {
    width: 1224px;
    margin-left: -12px;
    display: flex;
    flex-wrap: wrap;
  }
  .data-info {
    width: 282px;
    background: #ffffff;
    box-shadow: 0px 0px 14px 0px rgba(0, 12, 40, 0.14);
    border-radius: 6px;
    margin: 0 12px 24px 12px;
    transition: all 0.2s ease-out;
    &:hover {
      position: relative;
      transform: translateY(-6px);
    }
  }
  .data-img {
    width: 100%;
    height: 156px;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    margin-bottom: 15px;
  }
  .data-box {
    padding: 0 20px;
  }
  .data-title {
    display: block;
    font-size: 16px;
    color: #333;
    margin-bottom: 8px;
  }
  .data-tip {
    font-size: 12px;
    color: #999;
    margin-bottom: 20px;
  }
  .data-price {
    width: 100%;
    height: 54px;
    border-top: 1px solid #e5e5e5;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .price {
      font-size: 18px;
      font-weight: 800;
      color: #cd1b14;
    }
    .num {
      font-size: 12px;
      color: #999999;
    }
  }
  &.style_2 {
    .data-info:first-child {
      width: 588px;
      position: relative;
      .data-img {
        width: 100%;
        height: 100%;
        border-radius: 6px;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
      }
      .data-box {
        box-sizing: border-box;
        width: 100%;
        height: 88px;
        background-color: rgba(0, 12, 40, 0.4);
        border-radius: 0px 0px 6px 6px;
        position: absolute;
        bottom: 0;
        z-index: 2;
      }
      .data-title {
        padding: 18px 0 10px;
        color: #fff;
        margin: 0;
      }
      .data-tip {
  display: none;
}
.data-price {
  height: auto;
  border: none;
  .price {
    color: #fff;
  }
}
}
}
.active-list{
display: flex;
// justify-content: space-between;
.active-sub-title{
height: 20px;
font-size: 14px;
  color: #999;
  line-height: 20px;
  -webkit-line-clamp: 1;
    }
    .active-name{
      height: 44px;
      font-size: 16px;
      color: #333;
    }
    &.style_7{
      .active-info{
        width: 385px;
        height: 306px;
        background-color: #FFF;
        box-shadow: 0px 0px 14px 1px rgba(0,12,40,0.14);
        border-radius: 6px;
        overflow: hidden;
        cursor: pointer;
        transition: all 0.2s ease-out;
        margin-right: 24px;
        &:hover {
          position: relative;
          transform: translateY(-6px);
        }
      }
      .active-info:nth-child(3n){
        margin-right: 0;
      }
      .active-img{
        width: 100%;
        height: 217px;
        margin-bottom: 10px;
      }
      .active-cent{
        padding: 0 22px;
      }
    }

    &.style_8{
      .active-info{
        box-sizing: border-box;
        width: 385px;
        height: 123px;
        padding: 0 18px;
        background-color: #FFF;
        box-shadow: 0px 0px 14px 1px rgba(0,12,40,0.14);
        border-radius: 6px;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        transition: all 0.2s ease-out;
        &:hover {
          position: relative;
          transform: translateY(-6px);
        }
      }
      .active-img{
        width: 160px;
        height: 90px;
        border-radius: 6px;
      }
      .active-cent{
        width: 180px;
      }
    }
  }
  
  &.content2 {
    background-color: #fff;
    .boutique-info.big {
      width: 576px;
      position: relative;
      .boutique-img {
        position: absolute;
        width: 100%;
        height: 100%;
        margin-bottom: 0;
        z-index: 0;
      }
      .boutique-box {
        box-sizing: border-box;
        width: 100%;
        padding-top: 18px;
        background-color: rgba(0, 12, 40, 0.29);
        position: absolute;
        bottom: 0;
        left: 0;
        .boutique-title,
        .price,
        .num {
          color: #fff;
        }
      }
      .boutique-price {
        border: none;
      }
    }
  }
}

// 弹框
.taskHint-dialog {
  position: absolute;
  width: 570px;
  height: 410px;
  border-radius: 20px 20px 20px 20px;
  background-image: url("../../assets/pc/lmxy_bgm.png");
  background-color: linear-gradient( 180deg, #2973F0 0%, rgba(94,149,244,0.75) 25%, rgba(255,255,255,0) 100%);
  z-index: 9991;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  .taskHint-content {
    position: relative;
    .close {
      position: absolute;
      color: #2973F0;
      font-size: 24px;
      font-weight: 700;
      right: 30px;
      top: 30px;
    }
    .taskHint-img {
      padding-top: 15px;
      text-align: center;
    }
    .taskHint-text {
      display: flex;
      align-items: center;
      flex-direction: column;
      .title {
        font-weight: bold;
        font-size: 23px;
        color: #333333;
        line-height: 53px;
        text-align: center;
      }
      .text {
        width: 421px;
        height: 55px;
        font-weight: 500;
        font-size: 18px;
        color: #333333;
        line-height: 30px;
        text-align: center;
      }
      .but {
        display: block;
        width: 142px;
        height: 46px;
        background: #2973F0;
        border-radius: 8px 8px 8px 8px;
        font-weight: 500;
        font-size: 16px;
        color: #FFFFFF;
        line-height: 46px;
        text-align: center;
        margin-top: 30px;
      }
    }
  }
}
.maskSight-box {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  z-index: 999;
}
.live-date {
  font-size: 14px;
  color: #999;
  .live-end-label {
    font-size: 12px;
    color: #999;
    margin-left: 8px;
    padding: 2px 6px;
    background: #f5f5f5;
    border-radius: 2px;
  }
}

/* 首屏 Banner 全屏占位 */
.ordos-hero {
  height: 100vh;
  min-height: 720px;
}

/* 锚点滚动时，避开固定 header */
.ordos-module {
  scroll-margin-top: 100px;
}

/* 页面平滑滚动 */
html {
  scroll-behavior: smooth;
}
</style>
